import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import DatetimePicker from 'vuetify-datetime-picker'
import VCurrencyField from 'v-currency-field'
import moment from "moment"

moment.locale('de');
Vue.use(DatetimePicker);

Vue.config.productionTip = false

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyDDQ37CQEXqQD0hddwpor7KA69QS5g7HS0',
  locale: 'de'
});

Vue.use(VCurrencyField, {
  allowNegative: false,
  locale: 'de-DE',
  min: 0
});

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#wordpress-entschaedigungsmanager-tool')
